import React, { useEffect, useState, useRef, useContext } from "react";
import logo from '../../assets/Stormini_Titelbild.png';
import zeltbetreuungLogo from '../../assets/titelbilder_bereiche/Landing_ZB.png'; // Beispielpfade, anpassen!
import arbeitFreizeitLogo from '../../assets/titelbilder_bereiche/Landing_AF.png';
import parlamentLogo from '../../assets/titelbilder_bereiche/Landing_Parlament.png';
import logistikLogo from '../../assets/titelbilder_bereiche/Landing_Logistik.png';
import easterEggLogo from '../../assets/easter_egg_logo.png'; // Passe den Pfad ggf. an
import easterEggLogo2 from '../../assets/easter_egg_logo_1_zu_viel.png'; // Passe den Pfad ggf. an
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import './Home.css';

import { zb_password, parlament_password } from '../../App';
// Vars für das Easter Egg
const EASTER_EGG_CLICK_THRESHOLD = 15;
const EASTER_EGG_CLICK_THRESHOLD_2 = 200; // Neuer Schwellenwert für das zweite Easter Egg
const CLICK_RESET_DELAY_MS = 500; // 0.5 Sekunden (Kommentar korrigiert)

function Home() {
  const location = useLocation();
  const navigate = useNavigate();
  const [bereich, setBereich] = useState('');
  const [currentLogo, setCurrentLogo] = useState(logo);
  const [logoClickCount, setLogoClickCount] = useState(0); // Zähler für schnelle Klicksequenz
  const clickResetTimerRef = useRef(null);
  const [zeltPasswordEntered, setZeltPasswordEntered] = useState(Cookies.get('zbpasswordentered') === 'true');
  const [parlamentPasswordEntered, setParlamentPasswordEntered] = useState(Cookies.get('ppasswordentered') === 'true');
  const [totalLogoClicks, setTotalLogoClicks] = useState(0); // Gesamtzähler für Klicks

  const bereichLogoMap = {
    'Zeltbetreuung': zeltbetreuungLogo,
    'Arbeit/Freizeit': arbeitFreizeitLogo,
    'Parlament': parlamentLogo,
    'Logistik': logistikLogo,
  };

  const defaultLogo = logo; // Hauptlogo speichern

  useEffect(() => {
    // Bereich bei jeder Navigation frisch aus dem Cookie lesen — auch beim
    // Bereichswechsel über die Navbar ohne Vollreload (location.key ändert sich).
    const bereichCookie = Cookies.get('Bereich');
    setBereich(bereichCookie || '');

    // Aufräumen des Timers, wenn die Komponente unmounted wird
    return () => {
      if (clickResetTimerRef.current) {
        clearTimeout(clickResetTimerRef.current);
      }
    };
  }, [location]);

  useEffect(() => {
    const logoForBereich = bereichLogoMap[bereich] || defaultLogo;
    setCurrentLogo(logoForBereich);
  }, [bereich]); // Effekt wird bei Änderung von bereich ausgeführt

  const handleLogoClick = () => {
    // Bestehenden Timer löschen, falls vorhanden (für die schnelle Klicksequenz)
    if (clickResetTimerRef.current) {
      clearTimeout(clickResetTimerRef.current);
    }

    // Wenn das finale Easter Egg (Logo 2) bereits angezeigt wird, keine weitere Aktion.
    if (currentLogo === easterEggLogo2) {
      return;
    }

    const newTotalClicks = totalLogoClicks + 1;
    setTotalLogoClicks(newTotalClicks);

    const newFastClickCount = logoClickCount + 1;
    setLogoClickCount(newFastClickCount);

    if (newTotalClicks >= EASTER_EGG_CLICK_THRESHOLD_2) {
      setCurrentLogo(easterEggLogo2); // Zweites Easter Egg anzeigen
      setLogoClickCount(0); // Zähler für schnelle Klicks zurücksetzen
      // Der Timer für schnelle Klicks wird hier nicht neu gestartet, da das finale Logo erreicht ist.
    } else if (newFastClickCount >= EASTER_EGG_CLICK_THRESHOLD) {
      // Nur das erste Easter Egg anzeigen, wenn das zweite noch nicht erreicht wurde.
      // Und wenn es nicht bereits das easterEggLogo ist (um unnötige State-Updates zu vermeiden)
      if (currentLogo !== easterEggLogo) {
          setCurrentLogo(easterEggLogo); // Erstes Easter Egg anzeigen
      }
      setLogoClickCount(0); // Zähler für schnelle Klicks zurücksetzen für die nächste Sequenz
      // Der Timer für schnelle Klicks wird hier nicht neu gestartet, da die Sequenz erfolgreich war.
    } else {
      // Timer starten, um den Zähler für schnelle Klicks zurückzusetzen,
      // wenn nicht schnell genug geklickt wird.
      clickResetTimerRef.current = setTimeout(() => {
        setLogoClickCount(0);
      }, CLICK_RESET_DELAY_MS);
    }
  };

  // React-Navigation statt Vollreload; die Navbar liest den neuen Bereich
  // über ihren location-Effect aus dem Cookie.
  const handleBereichAuswahl = (cookieValue, bereich, passwordRequired = false, passwordCookie = null, setPasswordState = null, password = null) => {
    if (passwordRequired) {
      const passwordEntered = Cookies.get(passwordCookie) === 'true';
      if (passwordEntered) {
        Cookies.set('Team', cookieValue);
        Cookies.set('Bereich', bereich);
        setBereich(bereich);
        navigate("/home");
        return;
      }
      const enteredPassword = prompt("Bitte gib das Passwort ein:");
      if (enteredPassword === password) {
        Cookies.set(passwordCookie, 'true', { expires: 10 }); // Login 10 Tage speichern
        if (setPasswordState) {
          setPasswordState(true);
        }
        Cookies.set('Team', cookieValue);
        Cookies.set('Bereich', bereich);
        setBereich(bereich);
        navigate("/home");
      } else {
        alert("Falsches Passwort!");
      }
    } else {
      Cookies.set('Team', cookieValue);
      Cookies.set('Bereich', bereich);
      setBereich(bereich);
      navigate("/home");
    }
  };

  const handleZeltbetreuungClick = () => {
    handleBereichAuswahl('ZB', 'Zeltbetreuung', true, 'zbpasswordentered', setZeltPasswordEntered, zb_password);
  };

  const handleParlamentClick = () => {
    handleBereichAuswahl('P', 'Parlament', true, 'ppasswordentered', setParlamentPasswordEntered, parlament_password);
  };

  // Kacheln des aktuellen Bereichs. Reihenfolge ist grundsätzlich gleich,
  // pro Bereich wird aber die wichtigste Kachel nach oben gezogen:
  // Parlament -> "Parlament", Logistik -> "Dienstpläne".
  const homeTiles = [
    { to: '/jobportal', label: 'Jobportal' },
    { to: '/freizeit', label: 'Freizeit' },
    { to: '/dienstplaene', label: 'Dienstpläne' },
    { to: '/parlament', label: 'Parlament' },
  ];
  const topTilePathByBereich = {
    'Parlament': '/parlament',
    'Logistik': '/dienstplaene',
  };
  const topTilePath = topTilePathByBereich[bereich];
  const orderedHomeTiles = topTilePath
    ? [
        ...homeTiles.filter(tile => tile.to === topTilePath),
        ...homeTiles.filter(tile => tile.to !== topTilePath),
      ]
    : homeTiles;

  return (
    <ul>
      <main>
        <img src={currentLogo} alt="Logo" className="logo_picture" onClick={handleLogoClick} />
        {bereich ? (
          <div>
            {orderedHomeTiles.map(tile => (
              <Link
                key={tile.to}
                to={tile.to}
                className={`home_button bereich_button ${bereich.replace(/[^a-zA-Z0-9]/g, '-')}`}
              >
                {tile.label}
              </Link>
            ))}
          </div>
        ) : (
          <>
            <p className="bereich-auswahl-title">Zu welchem Bereich gehörst du?</p>
            <div className="bereich-auswahl">
              <button onClick={handleZeltbetreuungClick} className="bereich-auswahl_button">
                Zeltbetreuung
              </button>
              <button onClick={() => handleBereichAuswahl('AF', 'Arbeit/Freizeit')} className="bereich-auswahl_button">
                Arbeit/Freizeit
              </button>
              <button onClick={handleParlamentClick} className="bereich-auswahl_button">
                Parlament
              </button>
              <button onClick={() => handleBereichAuswahl('L', 'Logistik')} className="bereich-auswahl_button">
                Logistik
              </button>
            </div>
          </>
        )}
        <div className="notfallnummern-strip">
          <Link to="/notfallnummern" className="notfallnummern-link">
            Notfall oder Problem?
          </Link>
        </div>
      </main>
    </ul>
  );
}

export default Home;